// extracted by mini-css-extract-plugin
export default {"connection":"ConnectionStatusDescription_connection__3h89x","large":"ConnectionStatusDescription_large__dqhWs"};